export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7440.66577878.jpg";